// frontend/src/hooks/useScientificDashboard.ts

import { useState, useEffect, useCallback } from 'react';
import { ScientificDashboardService } from '../services/scientificDashboard.service';

export const useScientificDashboard = (traceId?: string) => {
  const [traces, setTraces] = useState<{ trace_id: string; dataset_name?: string }[]>([]);
  const [selectedTrace, setSelectedTrace] = useState<string | null>(traceId ?? null);
  const [story, setStory] = useState<any | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  // ============================================================
  // Lista de traces disponíveis
  // ============================================================
  const listTraces = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await ScientificDashboardService.getAvailableTraces();
      setTraces(data);
    } catch (err: any) {
      setError(
        err.response?.data?.error || err.message || 'Erro ao listar traces'
      );
    } finally {
      setLoading(false);
    }
  }, []);

  // ============================================================
  // Story científico de um trace
  // ============================================================
  const loadStory = useCallback(async (traceId: string) => {
    if (!traceId) return;
    try {
      setLoading(true);
      setError(null);
      const data = await ScientificDashboardService.getScientificSummary(traceId);
      setStory(data);
    } catch (err: any) {
      setError(
        err.response?.data?.error || err.message || 'Erro ao carregar história'
      );
    } finally {
      setLoading(false);
    }
  }, []);

  // ============================================================
  // Selecionar trace manualmente
  // (o useEffect abaixo cuida de carregar a story)
  // ============================================================
  const selectTrace = useCallback((traceId: string) => {
    setSelectedTrace(traceId);
  }, []);

  // ============================================================
  // Efeitos
  // ============================================================

  // Carrega a lista de traces ao montar
  useEffect(() => {
    listTraces();
  }, [listTraces]);

  // Define o trace inicial quando a lista chega (se nenhum foi escolhido)
  useEffect(() => {
    if (traces.length > 0 && !selectedTrace) {
      setSelectedTrace(traces[0].trace_id);
    }
  }, [traces, selectedTrace]);

  // Carrega a story quando o trace selecionado muda
  useEffect(() => {
    if (selectedTrace) {
      loadStory(selectedTrace);
    }
  }, [selectedTrace, loadStory]);

  return {
    traces,
    selectedTrace,
    story,
    loading,
    error,
    listTraces,
    loadStory,
    selectTrace,
  };
};